import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M27.58 11.693v2.66C15.482 14.832 5.88 24.85 6 37.039l.016 1.571c.008.834 1.05 1.207 1.586.567l1.023-1.221A25.9 25.9 0 0 1 27.578 28.7l-.006 2.74a2.693 2.693 0 0 0 4.665 1.84l8.921-9.59a3.14 3.14 0 0 0-.003-4.284l-8.913-9.55a2.693 2.693 0 0 0-4.662 1.837m1.795 16.095a.9.9 0 0 0-.898-.9 27.7 27.7 0 0 0-20.671 9.27c.341-11.027 9.332-19.914 20.465-20.025l.206-.001a.9.9 0 0 0 .898-.898v-3.54a.898.898 0 0 1 1.554-.613l8.913 9.55c.483.517.483 1.319.002 1.836l-8.922 9.59a.898.898 0 0 1-1.555-.614z",
      clipRule: "evenodd"
    }
  )
);
var SvgForwardOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ForwardOutlined_default = SvgForwardOutlined;

export { ForwardOutlined_default as default };
